import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/obligation.pdf'; 
import { Helmet } from 'react-helmet';

function Obligation() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series VI volume 4</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        pp 2152-2154<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: first half of 1677?<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (301k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On the Obligation to Believe</title>
            <meta name="description" content="An English translation of ON THE OBLIGATION TO BELIEVE by Gottfried Wilhelm Leibniz, from first half of 1677?" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE OBLIGATION TO BELIEVE</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A VI 4, 2152</b>]<br /><br />
                <center><var>On the Obligation to Believe<br />
                A Reasoning Which is Offered as a Demonstration</var></center><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>Definitions</var><br />
                <ol>
                <li><var>Obligation</var> is a necessity imposed by fear of just punishment.</li>
                <li> To <var>believe</var> is to be conscious of the reasons that convince us.</li>
                <li><var>In our power</var> are those things which happen if you will them.</li>
                <li><var>Fear</var> is the desire to avoid.</li>
                <li><var>Consciousness</var> is memory of our actions.</li></ol>

                [<b>A VI 4, 2153</b>]<br /><br />
                <center><var>Observation</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;It is not in our power to remember or not remember now something from the past.<br /><br />

                <center>Proposition I</center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>Consciousness is not in one's power</var>.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>Demonstration</var>: For consciousness is memory <var>by definition 5</var>. Memory is not in one's power, <var>by the preceding observation</var>. Therefore consciousness is not in one's power either.<br /><br />

                <center><var>Proposition II</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>It is not in one's power to believe something or not to believe it</var>.<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>Demonstration</var>: For to believe is to be conscious of reasons that convince us of what is to be believed, <var>by definition 2</var>. Consciousness is not in one's power, <var>by proposition 1</var>. Therefore, neither is it in one's power to believe something or not to believe it.<br /><br />

                <center><var>Proposition III</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>There is no obligation to do those things which are not in one's power</var>.<br /><br />

                [<b>A VI 4, 2154</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>Demonstration</var>: Since fear of punishment is nothing other than the desire to avoid punishment, <var>by definition 4</var>, it follows that nothing else in the obligated person can contribute to the fulfilment of the obligation than that person's desire to avoid punishment through obedience or complying. Since, therefore, it is clear from this that fear of punishment ought to produce nothing other than the desire to obey, and indeed obligation is the necessity which fear of punishment brings about, <var>by definition 1</var>, it follows that there is no obligation except for the desire to obey, and hence that there is no obligation to do those things which are not done even by assuming the desire to obey, that is, those things which are not in one's power, <var>by definition 3</var>.<br /><br />

                <center><var>Proposition IV</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<var>There is no obligation to believe, but only to inquire with the utmost effort</var>.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To believe is not in one's power, <var>by proposition 2</var>. There is no obligation to do those things which are not in one's power, <var>by proposition 3</var>. Therefore there is no obligation to believe. Which was to be demonstrated.<br /><br />

                <center><var>Corollary</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;From this it is clear that it is pointless hereafter to oblige someone by oath to believe or not to believe something.<br /><br />

                <center><var>Scholium</var></center><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;From this I gather that the obligation or command to believe entails nothing other than the utmost effort to believe, that is, the most meticulous investigation into the reasons for believing. This investigation, however, must be so moderated that we do not request a greater effort from anyone than the state of their affairs and way of life allows.<a name="1" href="#note1"><sup>1</sup></a> To understand this more clearly: at this present moment I am not obliged to believe or to remember something, because this does not depend on me. However, I am sometimes obliged to try to find reasons which I may remember, that is, believe, in future. By a similar method, most things in moral matters and natural theology could be demonstrated. That would be of the greatest importance for the tranquillity of the soul. For only demonstration brings certainty, only certainty brings enduring tranquillity, and only tranquillity brings happiness.
                <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />
                        NOTE:<br /><br />
                        <a name="note1" href="#1">1.</a> Here Leibniz wrote and then deleted the following: 'Nothing can be objected to this demonstration provided that one accepts the definitions I have given. But if anyone doubts them, the dispute ends, for the opponent declares that the words 'obligation', 'believing', etc. are taken in a sense different from mine. But I also declare that I am content with demonstrating the proposition according to the sense of the words I have taken, which I do not think differs from the usage of ordinary people'.
                        <br /><br /><br />
                        &#169; Lloyd Strickland 2004. Revised 2007
              <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Obligation;
